import * as Common from '@/agiles/common';
import { LicenseResult } from './stateObject';

export class PermissionControler{

    constructor(api: Common.Api){
        this.api = api;
    }
    private api: Common.Api;

    public  initialize(license : LicenseResult) {

        this.permissions = license.permissions;
        this.workflowActions = license.workflowActions;
        this.workflowPermissions = license.workflowPermissions;
        this.workflowControllers = license.workflowControllers;
        this.groups = license.groups;
        this.proxyUsers = license.proxyUsers;
        this.urlPermissions = license.urlPermissions;
        //パーミッションをロードする
        // await this.api.execute(new Common.UserPermissionQuery()).then(result=>{this.permissions = result as Common.Permission[];});
        // await this.api.execute(new Common.UserWorkflowActionQuery()).then(result=>this.workflowActions = result as Common.WorkflowAction[]);     
        // await this.api.execute(new Common.WorkflowControllerQuery()).then(result=>this.workflowControllers = result.result as Common.WorkflowController[]);  
        // await this.api.execute(new Common.UserGroupQuery()).then(result => this.groups = result as Common.GroupMember[]);   
        // await this.api.execute(new Common.ProxyUserQuery()).then(result => this.proxyUsers = result as Common.User[]);           
    }    

    private permissions: Common.Permission[];
    // private disallowPermissions: Common.Permission[];
    private workflowPermissions: Common.WorkflowPermission[];
    private workflowActions: Common.WorkflowAction[];
    private workflowControllers: Common.WorkflowController[];
    private groups: Common.GroupMember[];
    private proxyUsers: Common.User[];
    public hasMenuPermission(claim: string){
        if (claim == null || claim == '') return true;
        //前方一致からワイルドカード方式に変更
        //禁止を優先する。proxyUsersのPermissionは含まれない=>許可・禁止モデルから、許可・除外許可モデルに変更
        // for (const perm of this.disallowPermissions) {
        //     for(const item of perm.items){
        //         // if (claim.startsWith(item)) return false; //禁止
        //         if (this.hasScope(item,claim)) return false; //禁止
        //     }
        // }

        //許可集合の和を取って判定します。
        //proxyUsersのPermissionを含む
        for (const perm of this.permissions) {
            if (perm.mode == Common.permissionFlags.Include){
                for(const item of perm.items){
                    //一致するものがあればその時点で許可される
                    if (this.hasScope(item,claim)) return true; //許可
                }
            } else if (perm.mode == Common.permissionFlags.Exclude){
                var result = true;
                //全て一致しなければ許可される～一致するものが一つでもあると許可されない
                for(const item of perm.items){
                    if (this.hasScope(item,claim)) {
                        result = false; 
                        break;
                    }
                } 
                if (result) return true; //許可
            }
        }
        return false;
    }
    private hasScope(perm:string, claim:string):boolean {
        //permissionのスコープがclaimを含むかどうかを判定します。
        //ピリオド区切の固定階層とする
        //perm側のアスタリスクはワイルドカードとする
        const perms = perm.split(".");
        const claims = claim.split(".");
        if (claims.length > perms.length) return false;
        for(var i = 0; i< claims.length; i++){
            if (claims[i] != perms[i] && perms[i] != "*") return false;
        }
        return true;
    }
    public hasWorkflowPermission(workflowHolder: string): boolean {
        //伝票の要求する承認権限よりも大きい承認権限を探す
        const userId = this.api.auth.userId;
        if (workflowHolder==null || workflowHolder=='' || workflowHolder == userId) return true;

        //代行ユーザーを検索します
        if (this.proxyUsers.findIndex(u=>u.id == workflowHolder) >= 0) return true;

        for(const perm of this.groups){
            if (perm.groupId == workflowHolder) return true;
        }
        return false;
    }
    public getWorkflowState(workflowCode:string, workflowId:number,stateId:number): Common.WorkflowState {
        if (workflowId ==0){
            const entry = this.workflowControllers.find(obj=>obj.code == workflowCode);
            return entry.systemStates.find(obj=>obj.workflowStateId == stateId);
        } else {
            return this.workflowActions.find(obj=>obj.workflowCode == workflowCode && obj.workflowId == workflowId).workflow.getState(stateId);
        }

    }
    public getWorkflowActions(workflowCode:string, workflowId:number,stateId:number): Common.WorkflowAction[]{
        //遷移元:=stateIdでフィルタする。workflowId:=0の場合はシステムアクションを取得する
        if (workflowId ==0){
            const entry = this.workflowControllers.find(obj=>obj.code == workflowCode);
            return entry.systemActions.filter(obj=>obj.workflowId == workflowId && obj.stateIdFrom == stateId);
        } else {
            return this.workflowActions.filter(obj=>obj.workflowCode == workflowCode && obj.workflowId == workflowId && obj.stateIdFrom == stateId);
        }
    }
    public getWorkflowActionsHasPermission(workflowCode:string, workflowId:number,stateId:number): Common.WorkflowAction[]{
        var actions = this.getWorkflowActions(workflowCode, workflowId, stateId);
        var permissions = this.workflowPermissions.filter(obj => obj.workflowId == workflowId && obj.workflowStateId == stateId);
        return (permissions == null || permissions.length == 0 || this.hasWorkflowPermission(permissions[0].userId)) ? actions : new Array();
    }
    public getDefaultAction(workflowCode:string, workflowId:number,stateId:number, targetState: number): Common.WorkflowAction{
        var action = this.getWorkflowActions(workflowCode, workflowId, stateId).find(obj =>obj.stateIdTo ==  targetState && obj.templateId == null); //「送信する帳票」が設定されているアクションは除外する
        var permissions = this.workflowPermissions.filter(obj => obj.workflowId == workflowId && obj.workflowStateId == stateId);
        return (permissions == null || permissions.length == 0 || this.hasWorkflowPermission(permissions[0].userId)) ? action : null;
    }
  public getWorkflowStateLabel(item : Common.StateObject){
    if (!item || !item.workflowCode) return '';

    if (item.workflowHolder){
      return this.getWorkflowState(item.workflowCode, item.workflowId,item.workflowStateId).name + ' @ ' + this.api.formatter.formatByList(item.workflowHolder,'userGroup');
    } else {
      return this.getWorkflowState(item.workflowCode, item.workflowId,item.workflowStateId).name;
    }
  }    
  public getStateLabel(item : Common.StateObject, listName :string, isVirtual:boolean = false){
    if (!item || !listName) return '';

    var state = isVirtual ? (item as any).virtualState : item.state;
    if (item.workflowHolder){
      return this.api.formatter.formatByList(state, listName) + ' @ ' + this.api.formatter.formatByList(item.workflowHolder,'userGroup');
    } else {
      return this.api.formatter.formatByList(state, listName);
    }
  }    

  public isEntryStatus(item : Common.StateObject){
    if (item && item.workflowCode)
        return (this.getWorkflowState(item.workflowCode, item.workflowId, item.workflowStateId).type & Common.StateTypes.EntryStatus)  == Common.StateTypes.EntryStatus;
    else if (item)
        return true; //新規追加時
    else
        return false;
  }

  public hasWorkflow(workflowCode:string){
      return this.workflowActions.filter(obj =>obj.workflowCode == workflowCode && obj.workflowId !=0).length != 0;
  }
  public getLastUpdateLabel(item: any){
    if (!item) return '';

      if (item.lastUpdatedBy)
        return this.api.formatter.formatTimeStamp(item.lastUpdatedOn) + ' by ' + this.api.formatter.formatByList(item.lastUpdatedBy, 'user');
      else
        return this.api.formatter.formatTimeStamp(item.lastUpdatedOn);
  }
  public getDefaultWorkflowId(listName:string):number{
    const workflows = this.api.formatter.getOptions(listName);
    if (workflows.length > 0) return workflows[0].value;      
    else return 0;
  }
  public async reloadLicense()
  {
      var license : Common.LicenseResult = await this.api.execute(new Common.LicenseQuery());
      this.initialize(license);
  }


  //閲覧権限制御
  public urlPermissions: Common.BindItem[] = new Array();
  public setPermissionMessage : (msg:string)=>void; 

  public validateURL(path:string):boolean{
    //初回アクセス時のinitialize後のvalidation(2回目)
    if (this.setPermissionMessage){
     var claim = this.urlPermissions.find(obj =>(obj.text as string).toLowerCase() == path.toLowerCase());
     //未定義の場合は通過させる
     if (claim && this.hasMenuPermission(claim.value) == false){
        var menu = claim.value as string;
        if (this.setPermissionMessage) this.setPermissionMessage(this.api.getWord(menu.substring(menu.indexOf('.') + 1)));
        return false;
      }
      return true;

    } else {
      //初回アクセス時のbeforeEachはスルー(setPermissionMessageをセットした後のafterEachで判定)
      return true;
    }    
  }  
}

